import {
    PURCHASES_CLEAR_CART,
    PURCHASES_TOGGLE_OFFER,
    PurchasesAction
} from 'actions/purchases/PurchasesActionsTypes';

export const togglePurchaseOffer = (petUuid: string, offerId: string): PurchasesAction => ({
    type: PURCHASES_TOGGLE_OFFER,
    payload: { petUuid, offerId }
});

export const clearPurchaseCart = (): PurchasesAction => ({
    type: PURCHASES_CLEAR_CART
});
